import {
    h, Component, ComponentChildren
} from "preact";
import { srcset } from "../../foundation/utils/image";
import classname from "../../foundation/utils/classname";
import Dropdown from "../Dropdown";

import { getRolesByPaymentPlan } from "../../apps/entries/organization/dashboard/roles";

import "./style.css";

interface RoleOptionData {
    hidden?: boolean;
    icon?: string;
    displayName: string;
    extraInfo?: string;
    description: string;
    name: string;
}

interface RoleOptionProps {
    roleOptionData: RoleOptionData;
    class?: string;
}

interface Props {
    children?: ComponentChildren;
    optionsClass?: string;
    optionClass?: string;
    buttonClass?: string;
    paymentPlan: string;
    minRole?: string;
    maxRole?: string;
    selectedRole?: string;
    onChange: (value: string) => void;
}

interface State {
    selectedRole: string;
}

function RoleOptions({ roleOptionData: roleOptiondata, class: cssClass }: RoleOptionProps) {
    const {
        icon = "",
        displayName,
        extraInfo = "",
        description
    } = roleOptiondata;

    const iconSrc = `/img/${icon}.png`;
    const roleNameTextContent = [displayName, extraInfo].filter(Boolean).join(" ");

    return (
        <button type="button" class={classname("changeRolesRoleOption", cssClass)}>
            <img class="roleIcon" src={iconSrc} srcset={srcset(iconSrc)}/>
            <div class="roleNameAndDescription">
                <div class="roleName">{roleNameTextContent}</div>
                <div class="roleDescription">{description}</div>
            </div>
        </button>
    );
}

class ChangeRolePopup extends Component<Props, State> {
    override state = {
        selectedRole: this.props.selectedRole || ""
    };

    handleSelect = (value: string) => {
        this.setState({ selectedRole: value });
        this.props.onChange(value);
    };

    override componentWillReceiveProps(nextProps: Props) {
        if (nextProps.selectedRole && this.props.selectedRole !== nextProps.selectedRole) {
            this.setState({ selectedRole: nextProps.selectedRole });
        }
    }

    renderRoleOptions() {
        const { paymentPlan, minRole, maxRole, optionClass } = this.props;
        const roles = getRolesByPaymentPlan(paymentPlan);

        const findMinRoleIndex = minRole && roles.findIndex(role => role.name === minRole);
        const roleMin = findMinRoleIndex && findMinRoleIndex !== -1 ? findMinRoleIndex : roles.length - 1;

        const findMaxRoleIndex = maxRole && roles.findIndex(role => role.name === maxRole);
        const roleMax = findMaxRoleIndex && findMaxRoleIndex !== -1 ? findMaxRoleIndex : 0;

        const slicedRoleOptions = roles.slice(roleMax, roleMin + 1);
        const currentLabel = this.state.selectedRole
            ? this.state.selectedRole : slicedRoleOptions[slicedRoleOptions.length - 1].name;
        return slicedRoleOptions.map((role => (
            !role.hidden && (
                <Dropdown.Item
                    key={role.name}
                    value={role.name}
                    label={role.displayName}
                    selected={currentLabel === role.name}>
                    <RoleOptions roleOptionData={role} class={optionClass}/>
                </Dropdown.Item>
            )
        )));
    }

    render() {
        const {
            optionsClass, buttonClass, children
        } = this.props;

        return (
            <Dropdown
                class={classname("changeRolesDropdownButton", buttonClass)}
                showChevron={true}
                showCheck={false}
                options={{
                    class: classname("changeRolesRoleOptions", optionsClass)
                }}
                onChange={this.handleSelect}>
                {this.renderRoleOptions()}
                {children}
            </Dropdown>
        );
    }
}

export default ChangeRolePopup;
